import React, { Component } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import {
  Replay as ReloadIcon,
  AddCircleOutline as AddIcon,
  Delete,
  Edit,
} from "@material-ui/icons";

import DialogTrip from "./DialogTrip";
import FleetGrid from "../../../../ui/grid/FleetGrid";
import SearchButton from "../../../../ui/searchbutton/SearchButton";
import ConfirmDialog from "../../../../ui/confirmdialog/ConfirmDialog";

class EtaTrips extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { name: "slno", title: "Sl No." },
        { name: "tripname", title: "Trip Name" },
        { name: "routename", title: "Route Name" },
        { name: "stops", title: "Stops" },
        { name: "options", title: "Options" },
      ],
      rows: [
        {
          slno: "1",
          tripname: "Trip 1",
          routename: "Route 1",
          stops: "3",
          id: "111",
          options: this.getOptions({ id: "111", name: "Trip 1" }),
        },
        {
          slno: "2",
          tripname: "Trip 2",
          routename: "Route 2",
          stops: "2",
          id: "112",
          options: this.getOptions({ id: "112", name: "Trip 2" }),
        },
      ],
    };
  }

  getOptions = (rec) => {
    const { id, name } = rec;
    return (
      <div className="options">
        <Tooltip
          title="Edit"
          placement="bottom"
          onClick={() => this._tripDialog.toggleDialog(rec)}
        >
          <IconButton className="smallIcon">
            <Edit />
          </IconButton>
        </Tooltip>
        <Tooltip
          title="Delete"
          placement="bottom"
          onClick={() => this.deleteRecord(id, name)}
        >
          <IconButton className="smallIcon">
            <Delete />
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  onSearch = (e) => {
    console.log("this._tripsGrid: ", this._tripsGrid);
    // this._tripsGrid.onSearch(e.target.value.trim());
  };

  deleteRecord = (id, name) => {
    this._dialogConfirm.toggleConfirmDialog(id, name);
  };

  deleteAll = () => {
    this._dialogConfirm.toggleConfirmDialog("");
  };

  reload = () => {
    this._tripsGrid.loadReloadPoints();
  };

  addRoute = () => {
    this._tripDialog.toggleDialog({ add: true });
  };

  render() {
    const { columns, rows } = this.state;

    return (
      <div id="etaTrips">
        <ul id="gridFilters">
          <li>
            <SearchButton
              id="tripNameSearch"
              placeholder="Search By Trip or Route"
              buttonClass="pad5 iconButton searchBtn"
              inputClass="SearchInput"
              iconwidth="18"
              iconheight="18"
              onChange={this.onSearch}
            />
          </li>
          <li className="">
            <Tooltip title="Reload" placement="bottom">
              <IconButton onClick={this.reload}>
                <ReloadIcon />
              </IconButton>
            </Tooltip>
          </li>
          <li className="">
            <Tooltip title="Add Route" placement="bottom">
              <IconButton onClick={this.addRoute}>
                <AddIcon />
              </IconButton>
            </Tooltip>
          </li>
          <li className="">
            <Tooltip title="Delete" placement="bottom">
              <IconButton onClick={this.deleteAll}>
                <Delete />
              </IconButton>
            </Tooltip>
          </li>
        </ul>

        <FleetGrid
          columns={columns}
          rows={rows}
          childRef={(ref) => (this._tripsGrid = ref)}
        />

        <DialogTrip childRef={(ref) => (this._tripDialog = ref)} />

        <ConfirmDialog
          childRef={(ref) => (this._dialogConfirm = ref)}
          showConfirmDialog={false}
          id="confirmRouteDelete"
          name="Route"
        />
      </div>
    );
  }
}

export default EtaTrips;
